import React from 'react';
import {connect} from 'react-redux';
import {BaseCorrelationStackedTeams} from 'components/organisms/correlation-stacked-teams-list/components/base-correlation-stacked-teams';

class CorrelationStackedTeamsListComponent extends BaseCorrelationStackedTeams {
    render() {
        const {comboGroups} = this.props;

        const groupsUsedInLineups = comboGroups.getGroupsUsedInLineups();
        const groupsUnusedInLineups = comboGroups.getGroupsUnusedInLineups();

        if (isEmpty(groupsUsedInLineups) && isEmpty(groupsUnusedInLineups)) {
            return this.getView({
                content: this.getNotFoundView(),
            });
        }

        const usedCombinations = Object.values(groupsUsedInLineups).map((group, index) => {
            return this.getGroupOfUsedCombinationsView({index, group});
        });

        const unusedCombinations = Object.values(groupsUnusedInLineups).map((group, index) => {
            return this.getGroupOfUnusedCombinationsView({index, group});
        });

        return this.getView({
            content: [...usedCombinations, <div key="-1" className="unused-combinations"></div>, ...unusedCombinations],
        });
    }
}

function mapStatesToProps(state) {
    const {
        lineupsData,
        correlationStacking: {combinations},
        playersData,
    } = state;

    return {
        rawLineups: lineupsData.rawLineups,
        comboGroups: combinations.groups,
        players: playersData.players,
    };
}

const CorrelationStackedTeamsList = connect(mapStatesToProps)(CorrelationStackedTeamsListComponent);

export {CorrelationStackedTeamsList};
